import { Theme as AugmentedTheme } from '@mui/material/styles';


import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  headerContainer: {
    paddingBottom: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      paddingBottom: theme.spacing(1),
    },
  },
  addButton: {
    minWidth: '260px',
  },
  deleteButton: {
    color: theme.color.state.stateError,
  },
  instruction: {
    marginBottom: theme.spacing(4),
  },
  updatedBy: {
    marginTop: theme.spacing(4),
  },
  dialogButtonContainer: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column-reverse',
      marginLeft: theme.spacing(2),
      width: '100%',
    },
  },
  retrieveInstruction: {
    marginBottom: theme.spacing(2),
  },
  retrieveButton: {
    marginBottom: theme.spacing(3),
  },
  aaTypeSelectDropdown: {
    marginTop: theme.spacing(3),
  },
}));
